import React from "react";
import Upload from "@mui/icons-material/Upload.js";
import PropTypes from "prop-types";
import MDBox from "../../components/MDBox";

function UploadIcon({ value, color, icon = Upload, ...iconProps }) {
  const IconComponent = icon;

  return (
    <span style={{ position: "relative" }}>
      <IconComponent {...iconProps} color="disabled" style={{ margin: 0 }} />
      <MDBox
        component="span"
        sx={Object.assign(
          {
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            overflow: "hidden",
          },
          value || value == 0
            ? {
                transition: "height 200ms linear",
                height: value + "%",
              }
            : {
                "@keyframes upload": {
                  from: {
                    height: "0%",
                  },
                  to: {
                    height: "100%",
                  },
                },
                animation: `upload 3s infinite linear`,
              }
        )}
      >
        <IconComponent
          {...iconProps}
          color={color}
          style={{ position: "absolute", bottom: 0, left: 0 }}
        />
      </MDBox>
    </span>
  );
}

UploadIcon.propTypes = {
  value: PropTypes.number,
  size: PropTypes.number,
  color: PropTypes.string,
  icon: PropTypes.func,
};

export default UploadIcon;
